import { Text } from '@mantine/core'
import { useParams } from 'react-router-dom'
import { PageShell } from '@/components/ui'
import { ProjectAiAssistantWorkspace } from './ProjectAiAssistantWorkspace'

export function ProjectAiAssistantPage() {
  const { projectId = '' } = useParams<{ projectId: string }>()

  if (!projectId) {
    return (
      <PageShell>
        <Text size="sm">Не указан проект</Text>
      </PageShell>
    )
  }

  return (
    <PageShell>
      <ProjectAiAssistantWorkspace projectId={projectId} variant="page" />
    </PageShell>
  )
}
